<template>
  <div>
    <div>
      <div
        class="row w-100 justify-content-center"
        :style="{ display: this.isSubmitCredentials ? 'flex' : 'none' }"
      >
        <div
          class="col-lg-6 col-xl-4 align-self-center justify-content-center mb-3"
        >
          <div class="input-material mb-3">
            <input
              autofocus="false"
              type="text"
              placeholder="User Name"
              v-model="user_input"
            />
          </div>
          <div class="input-material mb-3">
            <input
              autofocus="false"
              type="password"
              placeholder="Password"
              v-model="user_password"
            />
          </div>
          <div class="text-center input-material">
            <b-button
              type="submit"
              variant="primary"
              @click="checkCredentials()"
              >Submit</b-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3" v-if="isSubmit">
        Global Option Private
      </div>
    </div>
    <div class="white-wrapper" v-if="isSubmit">
      <div v-for="(categ, categIndex) in globalDataList" :key="categIndex">
        <div class="row align-items-center my-2">
          <div class="h4 mx-3 ">{{ categ.category_name }}:</div>
          <p class=" h6 text-danger">
            {{ categ.desc ? "(" + categ.desc + ")" : "" }}
          </p>
        </div>
        <div class="row justify-content-between">
          <div
            class="col-lg-6 col-xl-4 align-self-center mb-3"
            v-for="(categData, categDataIndex) in categ.category_values"
            :key="categDataIndex"
          >
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="categData.go_value"
                  @input="updateGlobalData(categData)"
                />

                <label>{{ categData.go_key }}</label>
              </div>
              <i
                class="fa fa-copy"
                @click="copyKeyValue(categData.go_value)"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center input-material">
        <b-button
          type="submit"
          variant="primary"
          @click="editGlobalPrivateOptions()"
          >Submit</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import CryptoJS from "crypto-js";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      decryptedPassword: "",
      user_input: "",
      user_password: "",
      isSubmitCredentials: true,
      isSubmit: false,
      finalSaveData: [],
      globalDataList: [
        {
          category_id: 1,
          category_name: "Stripe Integration",
          category_key: "Payment Gateway",
          desc:
            "In Payment Mode , Stripe to be enable to use this service for online.",
          category_values: [
            {
              go_id: "",
              go_key: "STRIPE_SECRET_KEY",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "STRIPE_PUBLISHER_KEY",
              key_name: "",
              go_value: ""
            }
          ]
        },
        {
          category_id: 2,
          category_name: "TWILIO Integration",
          category_key: "SMS Gateway",
          desc: "To use WHATSAPP_PROVIDER the value should be twilio",
          category_values: [
            {
              go_id: "",
              go_key: "TWILIO_ACCOUNT_SID",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "TWILIO_AUTH_TOKEN",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "TWILIO_SENDER_NUMBER",
              key_name: "",
              go_value: ""
            }
            // {
            //   go_id: "",
            //   go_key: "WHATSAPP_PROVIDER",
            //   key_name: "",
            //   go_value: ""
            // }
          ]
        },
        {
          category_id: 3,
          category_name: "TWILIO FOR WHATSAPP",
          category_key: "SMS Gateway",
          desc: "To use SMS_PROVIDER the value should be twilio",
          category_values: [
            {
              go_id: "",
              go_key: "TWILIO_WHATSAPP_ACCOUNT_SID",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "TWILIO_WHATSAPP_AUTH_TOKEN",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "TWILIO_WHATSAPP_SENDER_NUMBER",
              key_name: "",
              go_value: ""
            }
            // {
            //   go_id: "",
            //   go_key: "SMS_PROVIDER",
            //   key_name: "",
            //   go_value: ""
            // }
          ]
        },
        {
          category_id: 4,
          category_name: "DEEPL",
          category_key: "Language Change",
          category_values: [
            {
              go_id: "",
              go_key: "DEEPL_API_KEY",
              key_name: "",
              go_value: ""
            }
          ]
        },
        {
          category_id: 5,
          category_name: "MAILCHIMP Service",
          category_key: "EMAIL SERVICE",
          category_values: [
            {
              go_id: "",
              go_key: "MAILCHIMP_API_KEY",
              key_name: "",
              go_value: ""
            }
          ]
        },
        {
          category_id: 6,
          category_name: "Fresh Desk Integration",
          category_key: "",
          category_values: [
            {
              go_id: "",
              go_key: "FRESH_DESK_KEY",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "FRESH_DESK_URL",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "FRESH_DESK_CONFIG",
              key_name: "",
              go_value: ""
            }
          ]
        },
        {
          category_id: 7,
          category_name: "FRESHCHAT",
          category_key: "WHATSAPP SERVICE",
          desc: "To use WHATSAPP_PROVIDER the value should be freshchat",
          category_values: [
            {
              go_id: "",
              go_key: "FRESHCHAT_WHATSAPP_FROM_NUMBER",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "FRESHCHAT_WHATSAPP_NAMESPACE",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "FRESHCHAT_WHATSAPP_AUTH_TOKEN",
              key_name: "",
              go_value: ""
            }
            // {
            //   go_id: "",
            //   go_key: "WHATSAPP_PROVIDER",
            //   key_name: "",
            //   go_value: ""
            // }
          ]
        },
        {
          category_id: 8,
          category_name: "CINEPOOL",
          category_key: "Movie Service",
          category_values: [
            {
              go_id: "",
              go_key: "CINEPOOL_KEY",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "CINEPOOL_URL",
              key_name: "",
              go_value: ""
            }
          ]
        },
        {
          category_id: 9,
          category_name: "SendGRID",
          category_key: "Mail Service",
          desc:
            "To use EMAIL_SERVICE_TYPE the value should be SMTP and SMTP_HOST_URL should be smtp.sendgrid.net",
          category_values: [
            {
              go_id: "",
              go_key: "SENDGRID_USER_NAME",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "SENDGRID_PASSWORD",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "SENDGRID_API_KEY",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "SENDER_EMAIL",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "EMAIL_SERVICE_TO_USE ",
              key_name: "",
              go_value: ""
            }
            // {
            //   go_id: "",
            //   go_key: "EMAIL_SERVICE_TYPE ",
            //   key_name: "",
            //   go_value: ""
            // },
            // {
            //   go_id: "",
            //   go_key: "SMTP_HOST_URL ",
            //   key_name: "",
            //   go_value: ""
            // }
          ]
        },
        {
          category_id: 10,
          category_name: "GMAIL SMTP",
          category_key: "Mail Service",
          desc:
            "To use EMAIL_SERVICE_TYPE the value should be SMTP and for SMP_HOST_URL value should be smtp.gmail.com",
          category_values: [
            {
              go_id: "",
              go_key: "SENDER_EMAIL",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "EMAIL_SERVICE_TO_USE ",
              key_name: "",
              go_value: ""
            },
            // {
            //   go_id: "",
            //   go_key: "EMAIL_SERVICE_TYPE ",
            //   key_name: "",
            //   go_value: ""
            // },
            // {
            //   go_id: "",
            //   go_key: "SMTP_HOST_URL",
            //   key_name: "",
            //   go_value: ""
            // },
            {
              go_id: "",
              go_key: "SMTP_USERNAME",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "SMTP_PASSWORD",
              key_name: "",
              go_value: ""
            }
          ]
        },
        {
          category_id: 11,
          category_name: "EMAIL FAILED",
          category_key: "",
          category_values: [
            {
              go_id: "",
              go_key: "ERROR_EMAIL_RECIPIENTS",
              key_name: "",
              go_value: ""
            }
          ]
        },
        {
          category_id: 12,
          category_name: "EMAIL Sent to More People",
          category_key: "",
          category_values: [
            {
              go_id: "",
              go_key: "EMAIL_BCC",
              key_name: "",
              go_value: ""
            }
          ]
        },
        {
          category_id: 13,
          category_name: "Safer Pay Integration",
          category_key: "Payment Gateway",
          desc:
            "In Payment Mode  , Safer Pay to be enable to use this service for online. ",
          category_values: [
            {
              go_id: "",
              go_key: "SAFER_PAY_AUTH_KEY",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "SAFER_PAY_TERMINAL_ID",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "SAFER_PAY_CUSTOMER_ID",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "SAFER_PAY_BASE_URL",
              key_name: "",
              go_value: ""
            }
          ]
        },
        {
          category_id: 14,
          category_name: "PLIVO ",
          category_key: "SMS Service",
          desc: "To use the value of SMS_PROVIDER the value should be Plivo",
          category_values: [
            {
              go_id: "",
              go_key: "PVILIO_NUMBER",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "PLIVO_AUTH_ID",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "PLIVO_AUTH_TOKEN",
              key_name: "",
              go_value: ""
            }
            // {
            //   go_id: "",
            //   go_key: "SMS_PROVIDER ",
            //   key_name: "",
            //   go_value: ""
            // }
          ]
        },
        {
          category_id: 15,
          category_name: "Brain Tree  ",
          category_key: "Payment Gateway",
          desc:
            "In Payment Mode  , Brain Tree to be enable to use this service for online. ",
          category_values: [
            {
              go_id: "",
              go_key: "BT_MERCHANT_ID",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "BT_ENVIRONMENT",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "BT_PUBLIC_KEY",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "BT_PRIVATE_KEY ",
              key_name: "",
              go_value: ""
            }
          ]
        },
        {
          category_id: 16,
          category_name: "CC Avenue",
          category_key: "Payment Gateway",
          desc:
            "In Payment Mode  , CC Avenue to be enable to use this service for online.",
          category_values: [
            {
              go_id: "",
              go_key: "CC_AVENUE_MERCHANT_ID",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "CC_AVENUE_ACCESS_CODE",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "CC_AVENUE_WORKING_KEY",
              key_name: "",
              go_value: ""
            }
          ]
        },
        {
          category_id: 17,
          category_name: "FTP ",
          category_key: "Filezilla Upload",
          desc: "Use for upload file to ftp, it onky works on port 21.",
          category_values: [
            {
              go_id: "",
              go_key: "FTP_HOST",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "FTP_USER",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "FTP_PASSWORD",
              key_name: "",
              go_value: ""
            }
          ]
        },
        {
          category_id: 18,
          category_name: "RazorPay",
          category_key: "",
          category_values: [
            {
              go_id: "",
              go_key: "RAZOR_PAY_KEY_ID",
              key_name: "",
              go_value: ""
            },
            {
              go_id: "",
              go_key: "RAZOR_PAY_KEY_SECRET",
              key_name: "",
              go_value: ""
            }
          ]
        }
      ],
      globalDataValues: [],
      globalVal: {
        go_id: "",
        go_key: "",
        key_name: "",
        go_value: ""
      }
    };
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;

    if (roleid != 1) {
      this.$router.go(-1);
    } else {
      this.getGlobalOptionsPrivate();
    }
  },
  computed: {},
  methods: {
    copyKeyValue(copy_data) {
      navigator.clipboard.writeText(copy_data);
      this.$toasted.show("Copied");
    },
    checkCredentials() {
      if (
        this.user_input == window.location.host.split(".")[0] &&
        this.user_password == this.decryptedPassword
      ) {
        this.isSubmitCredentials = false;
        this.isSubmit = true;
      } else {
        this.$toasted.show("Invalid Credentials");
      }
    },
    updateGlobalData(global_data_val) {
      let findIndex2 = this.finalSaveData.findIndex(x => {
        return x.go_id == global_data_val.go_id;
      });
      if (findIndex2 >= 0) {
        this.finalSaveData[findIndex2]["go_value"] = global_data_val.go_value;
      } else {
        this.finalSaveData.push(global_data_val);
      }
    },
    globalDataResult() {
      let array_key_check = [];
      this.globalDataList.map(x => {
        x.category_values.map(y => {
          this.globalDataValues.map(z => {
            if (z["go_key"].trim() == y["go_key"].trim()) {
              array_key_check.push(y["go_key"].trim());
              y.go_value = z.go_value;
              y.go_id = z.go_id;
            }
          });
        });
      });

      let otherCategory = {
        category_id: 0,
        category_name: "other",
        category_key: "",
        category_values: []
      };

      this.globalDataValues.map(x => {
        let checkIndexOf = array_key_check.indexOf(x.go_key.trim());
        if (checkIndexOf < 0) {
          let obj = {
            go_id: x.go_id,
            go_key: x.go_key,
            key_name: x.key_name,
            go_value: x.go_value
          };

          otherCategory.category_values.push(obj);
          // console.log(
          //   x.go_key.trim(),
          //   "Remaining Key",
          //   obj,
          //   otherCategory.category_values
          // );
        }
      });
      if (otherCategory.category_values.length > 0) {
        this.globalDataList.push(otherCategory);
      }
    },
    editGlobalPrivateOptions() {
      if (this.finalSaveData.length > 0) {
        let payload = {
          finalSaveData: this.finalSaveData,
          user_input: this.user_input,
          user_password: this.user_password
        };
        MasterService.EditGlobalPrivateOptions(payload).then(response => {
          const { data } = response;
          this.$toasted.show(data.message);
        });
      }
    },
    getGlobalOptionsPrivate: function() {
      MasterService.GetGlobalPrivateOptions()
        .then(response => {
          let global_data_response = CryptoJS.AES.decrypt(
            response.data.Records,
            response.data.organization_name
          );
          var password_decrypt = CryptoJS.AES.decrypt(
            response.data.password,
            response.data.organization_name
          );
          this.decryptedPassword = password_decrypt.toString(CryptoJS.enc.Utf8);

          const parse_data = global_data_response.toString(CryptoJS.enc.Utf8);
          const data = JSON.parse(parse_data);
          if (data) {
            this.globalDataValues = data;
            this.globalDataResult();
          }
        })
        .catch(this._CatchError);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/GlobalOptionsComponents/globalKeyOptions.vue